import type { HealthReport } from '@school-erp/types';

/**
 * Readiness returns 503 *with* a useful body when a dependency is down, so a non-2xx status
 * is only an error when the body is not a health report.
 */
export async function fetchHealth(signal?: AbortSignal): Promise<HealthReport> {
  const response = await fetch('/health/ready', {
    signal,
    headers: { Accept: 'application/json' },
  });
  const body: unknown = await response.json().catch(() => null);
  if (!isHealthReport(body)) {
    throw new Error(`Unexpected response (${response.status})`);
  }
  return body;
}

function isHealthReport(value: unknown): value is HealthReport {
  return (
    typeof value === 'object' &&
    value !== null &&
    'status' in value &&
    'checks' in value &&
    typeof (value as HealthReport).checks === 'object'
  );
}
